export default __webpack_public_path__ + "static/media/logo_bobike.318f397f.png";